import React from "react";
import { Clock, Ruler, Gauge, AlertTriangle } from "lucide-react";
import {
  formatDuration,
  formatDistance,
  CONGESTION_STYLES,
} from "./formatters";

const TrafficSection = ({ routeResponse }) => {
  const congestion = routeResponse.congestionLevel || "Unknown";
  const congestionStyle =
    CONGESTION_STYLES[congestion] || CONGESTION_STYLES.Unknown;

  return (
    <div className="grid grid-cols-2 gap-2 text-sm">
      <div className="flex items-center gap-2">
        <Clock className="h-4 w-4 text-gray-500 dark:text-gray-400 flex-shrink-0" />
        <div>
          <p className="text-xs text-gray-500 dark:text-gray-400">
            Travel Time
          </p>
          <p className="font-medium">
            {formatDuration(routeResponse.travelTimeSeconds)}
          </p>
        </div>
      </div>
      <div className="flex items-center gap-2">
        <Ruler className="h-4 w-4 text-gray-500 dark:text-gray-400 flex-shrink-0" />
        <div>
          <p className="text-xs text-gray-500 dark:text-gray-400">Distance</p>
          <p className="font-medium">
            {formatDistance(routeResponse.lengthMeters)}
          </p>
        </div>
      </div>
      <div className="flex items-center gap-2">
        <Gauge className="h-4 w-4 text-gray-500 dark:text-gray-400 flex-shrink-0" />
        <div>
          <p className="text-xs text-gray-500 dark:text-gray-400">Avg Speed</p>
          <p className="font-medium">
            {routeResponse.averageSpeedMph
              ? `${Math.round(routeResponse.averageSpeedMph)} mph`
              : "N/A"}
          </p>
        </div>
      </div>
      <div className="flex items-center gap-2">
        <AlertTriangle className="h-4 w-4 text-gray-500 dark:text-gray-400 flex-shrink-0" />
        <div>
          <p className="text-xs text-gray-500 dark:text-gray-400">Congestion</p>
          <div
            className="px-2 py-0.5 rounded text-xs font-medium inline-block"
            style={{
              backgroundColor: congestionStyle.bgColor,
              color: congestionStyle.textColor,
            }}
          >
            {congestion}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrafficSection;
